import styled from "styled-components";

export const WrapperApp = styled.div`
margin-left: 20px;
padding: 15px;
`;

export const TextApp = styled.p`
padding: 8px;
margin-left: 12px;
font-size: 18px;
font-weight: 500;
color: rgb(116, 114, 114);
width: fit-content;
`;

